import { CreditRslaWorksheet, EditCreditRslaWorksheetDto } from '@src/data/types/CreditRslaWorksheet'
import allApi from '../../api'
import { makeGetById, makeSave } from '../effects/standard-side-effects'
import {
  CreditRslaWorksheetSlice,
  GET_CREDIT_RSLA_WORKSHEET,
  SAVE_CREDIT_RSLA_WORKSHEET,
} from './credit-rsla-worksheet-store'

const autoRslaWorksheetEffects = {
  getById: (id: string) =>
    makeGetById<CreditRslaWorksheet>(
      GET_CREDIT_RSLA_WORKSHEET,
      allApi.creditRslaWorsheet.getById,
      CreditRslaWorksheetSlice.actions.setCurrent,
      {
        id,
      },
    ),
  create: (data: EditCreditRslaWorksheetDto) =>
    makeSave<EditCreditRslaWorksheetDto, CreditRslaWorksheet>(
      SAVE_CREDIT_RSLA_WORKSHEET,
      allApi.creditRslaWorsheet.create,
      CreditRslaWorksheetSlice.actions.setCurrent,
      data,
    ),
  update: (data: EditCreditRslaWorksheetDto) =>
    makeSave<EditCreditRslaWorksheetDto, CreditRslaWorksheet>(
      SAVE_CREDIT_RSLA_WORKSHEET,
      allApi.creditRslaWorsheet.update,
      CreditRslaWorksheetSlice.actions.setCurrent,
      data,
    ),
}

export default autoRslaWorksheetEffects
